import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { ToastProvider } from './components/common/ToastContext';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { UploadProvider } from './contexts/UploadContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <UploadProvider>
          <RouterProvider router={router} />
        </UploadProvider>
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);